import React from 'react';
import { Link } from 'react-router-dom';
import { LoadingSpinner, EmptyState, Button } from '../ui';

/**
 * PromptsTab - Manage pending/flagged prompts
 */
const PromptsTab = ({ prompts, loading, onApprove, onReject }) => {
  if (loading) {
    return <LoadingSpinner size="lg" text="Loading prompts..." />;
  }

  if (prompts.length === 0) {
    return (
      <EmptyState
        title="No pending prompts"
        message="Prompts appear here when they're flagged by content moderation or awaiting approval."
      />
    );
  }

  return (
    <div className="space-y-4">
      <h2 className="text-2xl font-semibold dark:text-white">Prompts Pending Review</h2>

      <div className="overflow-x-auto rounded-lg border dark:border-spooky-purple-mist">
        <table className="min-w-full text-left text-sm">
          <thead className="bg-gray-50 dark:bg-spooky-bg-light">
            <tr className="border-b dark:border-spooky-purple-mist">
              <th className="py-3 px-4 dark:text-white">Title</th>
              <th className="py-3 px-4 dark:text-white">Author</th>
              <th className="py-3 px-4 dark:text-white">Moderation</th>
              <th className="py-3 px-4 dark:text-white">Created</th>
              <th className="py-3 px-4 dark:text-white">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y dark:divide-spooky-purple-mist">
            {prompts.map((prompt) => (
              <tr key={prompt.id} className="hover:bg-gray-50 dark:hover:bg-spooky-bg-light dark:text-white">
                <td className="py-3 px-4 max-w-xs">
                  <div className="font-semibold truncate">{prompt.title}</div>
                  <div className="text-xs text-gray-500 truncate">{prompt.description}</div>
                </td>
                <td className="py-3 px-4">
                  {prompt.username}
                  {prompt.user_id && <div className="text-xs text-gray-500">ID: {String(prompt.user_id).slice(0, 8)}</div>}
                </td>
                <td className="py-3 px-4">
                  <span className="px-2 py-1 bg-yellow-100 dark:bg-yellow-900/30 text-yellow-800 dark:text-yellow-400 rounded text-xs">
                    {prompt.moderation_status}
                  </span>
                </td>
                <td className="py-3 px-4 text-xs text-gray-500">
                  {new Date(prompt.created_at).toLocaleDateString()}
                </td>
                <td className="py-3 px-4">
                  <div className="flex gap-2">
                    <Link
                      to={`/prompts/${prompt.id}`}
                      className="px-3 py-1 border dark:border-spooky-purple-mist rounded-lg text-xs hover:bg-gray-50 dark:hover:bg-spooky-bg-light"
                    >
                      View
                    </Link>
                    <Button
                      variant="primary"
                      size="sm"
                      onClick={() => onApprove(prompt.id)}
                    >
                      Approve
                    </Button>
                    <Button
                      variant="danger"
                      size="sm"
                      onClick={() => onReject(prompt.id)}
                    >
                      Reject
                    </Button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PromptsTab;
